import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat, dateFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const BasicInformation: FC<ViewProps> = ({ report, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#basic_information`}>
        <Headding icon={<Edit icon={16} />}>基本情報</Headding>
      </Link>
      <Item>
        <Grid>
          <Dl>
            <Dt>適用事業所</Dt>
            <Dd>{displayFormat(report.office?.name)}</Dd>
          </Dl>
          <Dl>
            <Dt>事業所の名称</Dt>
            <Dd>{displayFormat(report.officeSnapshot?.name)}</Dd>
          </Dl>
          <Dl>
            <Dt>都道府県</Dt>
            <Dd>{displayFormat(report.officeSnapshot?.prefecture?.name)}</Dd>
          </Dl>
          <Dl>
            <Dt>住所</Dt>
            <Dd>
              {displayFormat(report.officeSnapshot?.postcode0)}
              {'-'}
              {displayFormat(report.officeSnapshot?.postcode1)}
              <br />
              {displayFormat(report.officeSnapshot?.city)}
              {displayFormat(report.officeSnapshot?.houseNumber)}
              {displayFormat(report.officeSnapshot?.building)}
            </Dd>
          </Dl>
          <Dl>
            <Dt>電話番号</Dt>
            <Dd>
              {displayFormat(report.officeSnapshot?.phoneNumber0)}
              {'-'}
              {displayFormat(report.officeSnapshot?.phoneNumber1)}
              {'-'}
              {displayFormat(report.officeSnapshot?.phoneNumber2)}
            </Dd>
          </Dl>
          <Dl>
            <Dt>事業の種類</Dt>
            <Dd>{displayFormat(report.businessType?.name)}</Dd>
          </Dl>
          <Dl>
            <Dt>報告期間</Dt>
            <Dd>
              {dateFormat(report.startOn, 'YYYY/MM/DD')}
              {'～'}
              {dateFormat(report.endOn, 'YYYY/MM/DD')}
            </Dd>
          </Dl>
          <Dl>
            <Dt>報告回数</Dt>
            <Dd>{displayFormat(report.reportNumber)}</Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
